import { IconButton, Button } from '@/shared/ui/primitives';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { AddIcon } from '@/shared/ui/icons/AddIcon';
import { TEST_IDS } from '@/testIds';
import { paths } from '@/navigation/paths';

interface ClientsToolbarProps {
  isSelectionMode: boolean;
  onSelectAll: () => void;
}

export const ClientsToolbar: FC<ClientsToolbarProps> = ({ isSelectionMode, onSelectAll }) => {
  const navigate = useNavigate();

  const handleAddClient = (): void => {
    void navigate(paths.addClient());
  };

  if (isSelectionMode) {
    return (
      <Button variant="ghost" size="sm" onClick={onSelectAll}>
        Select all
      </Button>
    );
  }

  return (
    <IconButton
      size="md"
      variant="ghost"
      onClick={handleAddClient}
      data-testid={TEST_IDS.addClientButton}
      aria-label="Add client"
    >
      <AddIcon />
    </IconButton>
  );
};
